module.exports = __webpack_public_path__ + "static/media/12.d00b3549.jpg";